import { clearAuthCookies } from "./cookies";
import { cleanupChatNotificationsBeforeLogout } from "@/lib/firebase/logoutCleanup";

export const logout = async () => {
  try {
    await cleanupChatNotificationsBeforeLogout();
  } finally {
    clearAuthCookies();
    window.location.replace("/login");
  }
};
